import React from 'react';
import { Bell, Calendar, Clock, CheckCircle, AlertTriangle } from 'lucide-react';
import { theme } from '../../theme';

const ProjectStatusCard = ({ 
  currentProject, 
  projectStatus, 
  formatDate, 
  upcomingMilestones, 
  viewMode 
}) => {
  // Define status indicator based on project status
  const getStatusIndicator = (status) => {
    switch(status) {
      case 'on-track': 
        return <CheckCircle size={18} className="text-green-500 mr-2" />;
      case 'at-risk': 
        return <AlertTriangle size={18} className="text-amber-500 mr-2" />;
      case 'delayed': 
        return <Clock size={18} className="text-red-500 mr-2" />;
      default: 
        return <CheckCircle size={18} className="text-green-500 mr-2" />;
    }
  };

  return (
    <div className="bg-white border-b border-gray-100 p-4 md:px-6 transition-all duration-300">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div className="flex flex-col md:flex-row md:items-center">
            <div className="flex items-center p-3 bg-gray-50 rounded-lg">
              {getStatusIndicator(currentProject?.status)}
              <div>
                <span className="font-medium text-gray-800">{currentProject?.name}</span>
                <div className="flex items-center text-xs mt-1">
                  <span className="text-gray-500">Status: </span>
                  <span className={`ml-1 ${
                    currentProject?.status === 'on-track' ? 'text-green-600' : 
                    currentProject?.status === 'at-risk' ? 'text-amber-600' : 'text-red-600'
                  }`}>
                    {projectStatus.text}
                  </span>
                </div>
              </div>
            </div>
            
            <div className="flex items-center mt-3 md:mt-0 md:ml-6">
              <Calendar size={16} className="text-gray-400 mr-2" />
              <div>
                <span className="text-xs text-gray-500">Due date</span>
                <div className="font-medium text-gray-800">{formatDate(currentProject?.dueDate)}</div>
              </div>
            </div>
          </div>
          
          <div className="flex flex-wrap gap-2 mt-3 md:mt-0">
            {/* Only show milestones if available */}
            {upcomingMilestones && upcomingMilestones.length > 0 && (
              viewMode !== 'mobile' ? (
                <>
                  <div className="text-xs text-gray-500 w-full md:w-auto mb-1 md:mb-0 md:mr-2">Upcoming:</div>
                  {upcomingMilestones.slice(0, 2).map((milestone, idx) => (
                    <div key={idx} className="flex items-center bg-gray-50 px-3 py-2 rounded-lg text-sm">
                      <Bell size={14} className="mr-2 text-green-600" />
                      <div>
                        <div className="font-medium text-gray-800">{milestone.name}</div>
                        <div className="text-xs text-gray-500">{milestone.days} days remaining</div>
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <div className="flex items-center bg-gray-50 px-3 py-2 rounded-lg text-sm w-full justify-between">
                  <div className="flex items-center">
                    <Bell size={14} className="mr-2 text-green-600" />
                    <span className="font-medium text-gray-800">{upcomingMilestones[0]?.name}</span>
                  </div>
                  <span className="text-xs text-gray-500">{upcomingMilestones[0]?.days} days</span>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectStatusCard;
